<template>
  <v-container>
    <v-form ref="form" class="mic_form mic_container">
      <v-toolbar card color="#5ba322" dark class="mic_form-spacer">
        <v-toolbar-title>Vorschau</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-subheader
        class="mic_subheader"
      >Bitte überprüfen Sie Ihre Eingaben auf Korrektheit. Sind Ihre Eingaben korrekt so drücken Sie auf speichern um fortzufahren.</v-subheader>
      <div class="mic_form-content">
        <v-layout>
          <v-flex xs12 md9>
            <v-text-field
              v-model="trackingDayFormatted"
              label="Datum Verlaufskontrolle *"
              :disabled="true"
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex xs12 md9>
            <v-text-field
              v-model="tracking.trackingType"
              label="Art der Verlaufskontrolle *"
              :disabled="true"
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex xs12 md9>
            <v-text-field
              v-model="tracking.waistSize.value"
              label="Taillenweite (in cm) *"
              :disabled="true"
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex xs12 md9>
            <v-text-field
              v-model="tracking.hipsSize.value"
              label="Hüftweite (in cm)"
              :disabled="true"
              v-show="tracking.hipsSize.value"
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex xs12 md9>
            <v-text-field v-model="tracking.weight.value" label="Gewicht (in kg) *" :disabled="true"></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex xs12 md9>
            <v-text-field v-model="tracking.height.value" label="Größe (in cm) *" :disabled="true"></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex xs12 md9>
            <v-text-field
              v-model="tracking.weeklyHoursMotion.value"
              label="Stunden Bewegung pro Woche *"
              :disabled="true"
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex xs12 md9>
            <v-text-field
              v-model="tracking.amountOfFood"
              label="Nahrungsmenge"
              :disabled="true"
              v-show="tracking.amountOfFood"
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex xs12 md9>
            <v-radio-group
              v-model="tracking.snacks"
              :disabled="true"
              label="Zwischensnacks zwischen oder nach den drei Hauptmahlzeiten"
            >
              <v-radio label="Ja" :value="true"></v-radio>
              <v-radio label="Nein" :value="false"></v-radio>
            </v-radio-group>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex xs12 md9>
            <v-layout>
              <v-flex xs12 md6>
                <v-text-field
                  class="mic_double-item-input-row"
                  v-model="tracking.bloodPressure.systolic.value"
                  label="Blutdruck"
                  :disabled="true"
                  v-show="tracking.bloodPressure.systolic.value"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md3>
                <v-text-field
                  class="mic_double-item-input-row"
                  v-model="tracking.bloodPressure.diastolic.value"
                  label="zu"
                  :disabled="true"
                  v-show="tracking.bloodPressure.diastolic.value"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md3>
                <v-text-field
                  v-model="tracking.bloodPressure.posture"
                  :disabled="true"
                  v-show="tracking.bloodPressure.posture"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex xs12 md9>
            <v-text-field
              v-model="tracking.physicalAbility"
              label="Körperliche Leistungsfähigkeit *"
              :disabled="true"
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex xs12 md9>
            <v-text-field
              v-model="tracking.wellBeing"
              label="Wohlbefinden / Lebensqualität  *"
              :disabled="true"
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex xs12 md9>
            <v-text-field
              v-model="tracking.objectiveAchievement"
              label="Ziele zu erreichen"
              :disabled="true"
              v-show="tracking.objectiveAchievement"
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex xs12 md9>
            <v-text-field
              v-model="tracking.easyOfConversion"
              label="Wie leicht (Bitte erst bei 2. und 3. Verlaufskontrolle ausfüllen)"
              :disabled="true"
              v-show="tracking.easyOfConversion"
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex xs12 md9>
            <v-text-field
              v-model="tracking.benefit"
              label="Wie vorteilhaft (Bitte erst bei 2. und 3. Verlaufskontrolle ausfülle"
              :disabled="true"
              v-show="tracking.benefit"
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout v-show="tracking.bloodsugar.value">
          <v-flex xs12 md8>
            <v-text-field
              class="mic_double-item-input-row"
              v-model="tracking.bloodsugar.value"
              label="Blutzucker"
              :disabled="true"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md1>
            <v-text-field v-model="tracking.bloodsugar.unit" :disabled="true"></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout v-show="tracking.longtermSugar.value">
          <v-flex xs12 md8>
            <v-text-field
              class="mic_double-item-input-row"
              v-model="tracking.longtermSugar.value"
              label="Langzeitzucker"
              :disabled="true"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md1>
            <v-text-field v-model="tracking.longtermSugar.unit" :disabled="true"></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout v-show="tracking.triglycerides.value">
          <v-flex xs12 md8>
            <v-text-field
              class="mic_double-item-input-row"
              v-model="tracking.triglycerides.value"
              label="Triglyzeride"
              :disabled="true"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md1>
            <v-text-field v-model="tracking.triglycerides.unit" :disabled="true"></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout v-show="tracking.cholesterol.value">
          <v-flex xs12 md8>
            <v-text-field
              class="mic_double-item-input-row"
              v-model="tracking.cholesterol.value"
              label="Cholesterin"
              :disabled="true"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md1>
            <v-text-field v-model="tracking.cholesterol.unit" :disabled="true"></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout v-show="tracking.hdlCholesterol.value">
          <v-flex xs12 md8>
            <v-text-field
              class="mic_double-item-input-row"
              v-model="tracking.hdlCholesterol.value"
              label="HDL"
              :disabled="true"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md1>
            <v-text-field v-model="tracking.hdlCholesterol.unit" :disabled="true"></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout v-show="tracking.ldlCholesterol.value">
          <v-flex xs12 md8>
            <v-text-field
              class="mic_double-item-input-row"
              v-model="tracking.ldlCholesterol.value"
              label="LDL"
              :disabled="true"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md1>
            <v-text-field v-model="tracking.ldlCholesterol.unit" :disabled="true"></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout v-show="tracking.gptAltAlat.value">
          <v-flex xs12 md8>
            <v-text-field
              class="mic_double-item-input-row"
              v-model="tracking.gptAltAlat.value"
              label="GPT (bzw. ALT oder ALAT)"
              :disabled="true"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md1>
            <v-text-field v-model="tracking.gptAltAlat.unit" :disabled="true"></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout v-show="tracking.gotAstAsat.value">
          <v-flex xs12 md8>
            <v-text-field
              class="mic_double-item-input-row"
              v-model="tracking.gotAstAsat.value"
              label="GOT (bzw. AST oder ASAT)"
              :disabled="true"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md1>
            <v-text-field v-model="tracking.gotAstAsat.unit" :disabled="true"></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout v-show="tracking.ygtGgetGammaGT.value">
          <v-flex xs12 md8>
            <v-text-field
              class="mic_double-item-input-row"
              v-model="tracking.ygtGgetGammaGT.value"
              label="yGT (bzw. GGT oder Gamma-GT)"
              :disabled="true"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md1>
            <v-text-field v-model="tracking.ygtGgetGammaGT.unit" :disabled="true"></v-text-field>
          </v-flex>
        </v-layout>
      </div>
      <div class="mic_form-content">
        <v-btn color="#f5a900" @click="save" class="white--text">Endgültig Speichern</v-btn>
        <v-btn color="#f5a900" @click="back" class="white--text">Korrektur</v-btn>
      </div>
    </v-form>
  </v-container>
</template>

<script>
import { trackingService } from '../_services'
export default {
  data () {
    return {
      tracking: {}
    }
  },
  beforeMount () {
    this.tracking = JSON.parse(localStorage.getItem('previewTrackingData'))
    // if (!this.tracking.highBloodPressureMedicine) {
    //   this.tracking.highBloodPressureMedicine = false
    //   this.tracking.highBloodPressureMedicineItems = []
    // } else {
    //   this.tracking.highBloodPressureMedicineItems = this.tracking.highBloodPressureMedicine
    //   this.tracking.highBloodPressureMedicine = true
    // }
    // if (!this.tracking.diabetesMedicine) {
    //   this.tracking.diabetesMedicine = false
    //   this.tracking.diabetesMedicineItems = []
    // } else {
    //   this.tracking.diabetesMedicineItems = this.tracking.diabetesMedicine
    //   this.tracking.diabetesMedicine = true
    // }
  },
  computed: {
    trackingDayFormatted () {
      return this.formatDate(this.tracking.trackingDay)
    }
  },
  methods: {
    save () {
      const { dispatch } = this.$store

      // var cleanedHighBloodPressureMedicineItems = []
      // for (
      //   var i = 0;
      //   i < this.tracking.highBloodPressureMedicineItems.length;
      //   i++
      // ) {
      //   if (
      //     this.tracking.highBloodPressureMedicineItems[i].name &&
      //     this.tracking.highBloodPressureMedicineItems[i].dosis.value &&
      //     this.tracking.highBloodPressureMedicineItems[i].dosis.unit &&
      //     this.tracking.highBloodPressureMedicineItems[i].dailyAmount
      //   ) {
      //     var formattedHighBloodPressureMedicineItem = {
      //       name: this.tracking.highBloodPressureMedicineItems[i].name,
      //       id: this.tracking.highBloodPressureMedicineItems[i].id,
      //       dosis: {
      //         value: this.tracking.highBloodPressureMedicineItems[i].dosis.value.replace(',', '.'),
      //         unit: this.tracking.highBloodPressureMedicineItems[i].dosis.unit
      //       },
      //       dailyAmount: this.tracking.highBloodPressureMedicineItems[i]
      //         .dailyAmount
      //     }
      //     cleanedHighBloodPressureMedicineItems.push(
      //       formattedHighBloodPressureMedicineItem
      //     )
      //   }
      // }

      // var cleanedDiabetesMedicineItems = []
      // for (var j = 0; j < this.tracking.diabetesMedicineItems.length; j++) {
      //   if (
      //     this.tracking.diabetesMedicineItems[j].name &&
      //     this.tracking.diabetesMedicineItems[j].dosis.value &&
      //     this.tracking.diabetesMedicineItems[j].dosis.unit &&
      //     this.tracking.diabetesMedicineItems[j].dailyAmount
      //   ) {
      //     var formattedDiabetesMedicineItem = {
      //       name: this.tracking.diabetesMedicineItems[j].name,
      //       id: this.tracking.diabetesMedicineItems[j].id,
      //       dosis: {
      //         value: this.tracking.diabetesMedicineItems[j].dosis.value.replace(
      //           ',',
      //           '.'
      //         ),
      //         unit: this.tracking.diabetesMedicineItems[j].dosis.unit
      //       },
      //       dailyAmount: this.tracking.diabetesMedicineItems[j].dailyAmount
      //     }
      //     cleanedDiabetesMedicineItems.push(formattedDiabetesMedicineItem)
      //   }
      // }
      let tracking = {
        trackingDay: this.tracking.trackingDay,
        trackingType: this.tracking.trackingType,
        waistSize: {
          value: this.tracking.waistSize.value.replace(',', '.')
        },
        hipsSize: {
          value: this.tracking.hipsSize.value.replace(',', '.')
        },
        weight: {
          value: this.tracking.weight.value.replace(',', '.')
        },
        height: {
          value: this.tracking.height.value.replace(',', '.')
        },
        weeklyHoursMotion: {
          value: this.tracking.weeklyHoursMotion.value.replace(',', '.')
        },
        amountOfFood: this.tracking.amountOfFood,
        snacks: this.tracking.snacks,
        bloodPressure: this.tracking.bloodPressure,
        physicalAbility: this.tracking.physicalAbility,
        wellBeing: this.tracking.wellBeing,
        objectiveAchievement: this.tracking.objectiveAchievement,
        easyOfConversion: this.tracking.easyOfConversion,
        benefit: this.tracking.benefit,
        // highBloodPressureMedicine: cleanedHighBloodPressureMedicineItems,
        // diabetesMedicine: cleanedDiabetesMedicineItems,
        bloodsugar: {
          value: this.tracking.bloodsugar.value.replace(',', '.'),
          unit: this.tracking.bloodsugar.unit
        },
        longtermSugar: {
          value: this.tracking.longtermSugar.value.replace(',', '.'),
          unit: this.tracking.longtermSugar.unit
        },
        triglycerides: {
          value: this.tracking.triglycerides.value.replace(',', '.'),
          unit: this.tracking.triglycerides.unit
        },
        cholesterol: {
          value: this.tracking.cholesterol.value.replace(',', '.'),
          unit: this.tracking.cholesterol.unit
        },
        hdlCholesterol: {
          value: this.tracking.hdlCholesterol.value.replace(',', '.'),
          unit: this.tracking.hdlCholesterol.unit
        },
        ldlCholesterol: {
          value: this.tracking.ldlCholesterol.value.replace(',', '.'),
          unit: this.tracking.ldlCholesterol.unit
        },
        gptAltAlat: {
          value: this.tracking.gptAltAlat.value.replace(',', '.'),
          unit: this.tracking.gptAltAlat.unit
        },
        gotAstAsat: {
          value: this.tracking.gotAstAsat.value.replace(',', '.'),
          unit: this.tracking.gotAstAsat.unit
        },
        ygtGgetGammaGT: {
          value: this.tracking.ygtGgetGammaGT.value.replace(',', '.'),
          unit: this.tracking.ygtGgetGammaGT.unit
        },
        userId: JSON.parse(localStorage.getItem('user')).id
      }
      trackingService.saveTracking(tracking).then(
        response => {
          localStorage.removeItem('previewTrackingData')
          dispatch(
            'alert/success',
            'Dateneingabe wurde erfolgreich gespeichert.',
            { root: true }
          )
          this.$router.push('/tracking/overview')
        },
        error => {
          console.log(error)
          dispatch('alert/error', 'Fehler beim Speichern der Daten.', {
            root: true
          })
        }
      )
    },
    back () {
      this.$router.push('/tracking')
    },
    formatDate (date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${day}.${month}.${year}`
    }
  }
}
</script>

<style scoped="true">
.mic_subheader {
  margin-top: 25px;
}
.mic_double-item-input-row {
  padding-right: 25px;
}
</style>



// WEBPACK FOOTER //
// src/tracking/PreviewPage.vue